var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1492_90774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.45456 20.9578V11.685L2.57878 9.05409L0 7.59412V19.3214C0 20.2268 0.733594 20.9578 1.63641 20.9578H5.45456Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5449 20.9578H22.3631C23.2686 20.9578 23.9995 20.2241 23.9995 19.3214V7.59424L21.0786 9.26646L18.5449 11.685V20.9578Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45381 11.685L5.0625 8.06183L5.45381 4.59412L11.9993 9.50324L18.5447 4.59412L18.9824 7.87462L18.5447 11.685L11.9993 16.5941L5.45381 11.685Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5449 4.5941V11.685L23.9995 7.5941V5.41225C23.9995 3.38866 21.6895 2.23506 20.0723 3.44866L18.5449 4.5941Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.59414L2.50866 9.4757L5.45456 11.685V4.59414L3.92719 3.4487C2.30719 2.23501 0 3.3887 0 5.4122V7.59405V7.59414Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1492_90774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18.0938,
    fill: "white",
    transform: "translate(0 2.95312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.594f2006315b225726528bb38916e37e.svg";
export { ForwardRef as ReactComponent };